import { render, staticRenderFns } from "./datumList.vue?vue&type=template&id=39f21a6e&scoped=true&"
import script from "./datumList.vue?vue&type=script&lang=js&"
export * from "./datumList.vue?vue&type=script&lang=js&"
import style0 from "./datumList.vue?vue&type=style&index=0&id=39f21a6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f21a6e",
  null
  
)

export default component.exports